import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-carosel',
  templateUrl: './carosel.component.html',
  styleUrls: ['./carosel.component.scss']
})
export class CaroselComponent implements OnInit { 
  autoPlay=0;
  slideIndex = 0;
  private setTimeoutN;
  private setTimeoutS = [];
  
  ngOnInit(): void {
    this.autoslide();
  }
  ngOnDestroy(): void {
    this.myTimeoutStop();
  }
  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }
  stop(val){ 
    if(val){
      this.myTimeoutStop();
    }else{
      this.autoslide();
    }
  }
   currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }
  
   showSlides(n) {
    var i;
    var slides = Array.from(document.getElementsByClassName('mySlides') as HTMLCollectionOf<HTMLElement>)
    // document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    if (n > slides.length) {this.slideIndex = 1}    
    if (n < 1) {this.slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";  
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[this.slideIndex-1].style.display = "block";  
    dots[this.slideIndex-1].className += " active";
    
  }
  autoslide () {
  // console.log("_______________________",this.slideIndex)
  var i; 
  const slides = document.getElementsByClassName('mySlides'); 
  var dots = document.getElementsByClassName("dot"); 
  for (i = 0; i < slides.length; i++) {
    const slide = slides[i] as HTMLElement;
    slide.style.display = "none";  
  }
  this.slideIndex++;
  if (this.slideIndex > slides.length) {this.slideIndex = 1}    
  for (i = 0; i < dots.length; i++) {
    const dot = dots[i] as HTMLElement;
    dot.className = dots[i].className.replace(" active", "");
  }
  const slide = slides[this.slideIndex-1] as HTMLElement;
  if(slide!=null)
  slide.style.display = "block";  
  const dot = dots[this.slideIndex-1] as HTMLElement;
  dot.className += " active";
  
  this.myTimeoutStop();
  this.setTimeoutN = window.setTimeout( () => this.autoslide(), 10000);
  
  this.setTimeoutS.push(this.setTimeoutN)//
  // if(this.slideIndex-1==2){
  //   this.slideIndex=0;
  //   this.autoPlay=setTimeout(()=>this.autoslide(), 2000);
  // }
  }
  
  myTimeoutStop() {
    if( this.setTimeoutS.length > 0 ) {
        for (let id in this.setTimeoutS) {
            // console.log("id = "+this.setTimeoutS[id]);
            clearTimeout(this.setTimeoutS[id]);
        }
        this.setTimeoutS = [];//clear IDs array
    }
  }  

}